/* Voxari — JS do tema (v2) */

document.addEventListener('DOMContentLoaded', function () {
  /* ---------- Slideshow do hero ---------- */
  document.querySelectorAll('[data-slideshow]').forEach(function (slideshow) {
    var slides = slideshow.querySelectorAll('.hero__slide');
    var dots = slideshow.querySelectorAll('.hero__dot');
    var interval = parseInt(slideshow.dataset.interval || '6000', 10);
    var current = 0;
    var timer = null;

    if (slides.length <= 1) return;

    function goTo(index) {
      slides[current].classList.remove('is-active');
      if (dots[current]) dots[current].classList.remove('is-active');
      current = (index + slides.length) % slides.length;
      slides[current].classList.add('is-active');
      if (dots[current]) dots[current].classList.add('is-active');
    }

    function start() {
      timer = setInterval(function () { goTo(current + 1); }, interval);
    }

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        clearInterval(timer);
        goTo(i);
        start();
      });
    });

    start();
  });

  /* ---------- Galeria: troca de imagem, zoom no hover e lightbox ---------- */
  document.querySelectorAll('[data-product-gallery]').forEach(function (gallery) {
    var mainWrap = gallery.querySelector('.product-gallery__main');
    var main = mainWrap ? mainWrap.querySelector('img') : null;
    var thumbs = gallery.querySelectorAll('.product-gallery__thumb');
    var lightbox = document.querySelector('[data-lightbox]');

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
        if (main) main.src = thumb.dataset.src;
      });
    });

    if (!mainWrap || !main) return;

    mainWrap.addEventListener('mousemove', function (e) {
      var rect = mainWrap.getBoundingClientRect();
      var x = ((e.clientX - rect.left) / rect.width) * 100;
      var y = ((e.clientY - rect.top) / rect.height) * 100;
      main.style.transformOrigin = x + '% ' + y + '%';
      main.style.transform = 'scale(1.9)';
    });
    mainWrap.addEventListener('mouseleave', function () {
      main.style.transform = 'none';
    });

    if (lightbox) {
      var lightboxImg = lightbox.querySelector('img');
      mainWrap.addEventListener('click', function () {
        lightboxImg.src = main.src;
        lightbox.classList.add('is-open');
        document.body.style.overflow = 'hidden';
      });
      function closeLightbox() {
        lightbox.classList.remove('is-open');
        document.body.style.overflow = '';
      }
      lightbox.addEventListener('click', function (e) {
        if (e.target !== lightboxImg) closeLightbox();
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') closeLightbox();
      });
    }
  });

  /* ---------- Seletor de variante: atualiza preço e parcelamento ---------- */
  document.querySelectorAll('[data-variant-select]').forEach(function (select) {
    var priceEl = document.querySelector('[data-product-price]');
    var instEl = document.querySelector('[data-product-installments]');
    select.addEventListener('change', function () {
      var option = select.options[select.selectedIndex];
      if (priceEl && option.dataset.price) priceEl.innerHTML = option.dataset.price;
      if (instEl && option.dataset.installment) instEl.innerHTML = option.dataset.installment;
    });
  });

  /* ---------- Seletor de quantidade (+ / −) ---------- */
  document.querySelectorAll('[data-qty]').forEach(function (qty) {
    var input = qty.querySelector('input');
    qty.querySelectorAll('button').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var step = btn.dataset.step === 'up' ? 1 : -1;
        var min = parseInt(input.min || '1', 10);
        input.value = Math.max(min, (parseInt(input.value, 10) || min) + step);
      });
    });
  });

  /* ---------- Calculadora de frete ---------- */
  var CEP_KEY = 'voxari_cep';

  function maskCep(input) {
    input.addEventListener('input', function () {
      var v = input.value.replace(/\D/g, '').slice(0, 8);
      input.value = v.length > 5 ? v.slice(0, 5) + '-' + v.slice(5) : v;
    });
  }

  function formatRatePrice(price) {
    var n = parseFloat(price);
    if (!n) return '<span class="rate-price free">Grátis</span>';
    return '<span class="rate-price">R$ ' + n.toFixed(2).replace('.', ',') + '</span>';
  }

  function fetchRates(cep) {
    var zip = cep.replace(/\D/g, '');
    /* Descobre o estado (UF) pelo CEP — a Shopify exige país e estado para cotar */
    return fetch('https://viacep.com.br/ws/' + zip + '/json/')
      .then(function (r) { return r.ok ? r.json() : {}; })
      .catch(function () { return {}; })
      .then(function (via) {
        if (via && via.erro) throw new Error('cep-invalido');
        var uf = via && via.uf ? via.uf : '';
        var url = '/cart/shipping_rates.json' +
          '?shipping_address[zip]=' + zip +
          '&shipping_address[country]=Brazil' +
          '&shipping_address[province]=' + encodeURIComponent(uf);
        var attempt = 0;
        return new Promise(function (resolve, reject) {
          function tryFetch() {
            fetch(url)
              .then(function (res) {
                if (res.status === 200) {
                  res.json().then(function (data) { resolve(data.shipping_rates || []); });
                } else if (res.status === 422) {
                  reject(new Error('unprocessable'));
                } else if (attempt++ < 8) {
                  setTimeout(tryFetch, 900);
                } else {
                  reject(new Error('timeout'));
                }
              })
              .catch(reject);
          }
          tryFetch();
        });
      });
  }

  function renderRates(list, rates) {
    if (!rates.length) {
      list.innerHTML = '<li>Nenhuma opção de entrega encontrada para este CEP.</li>';
      return;
    }
    list.innerHTML = rates.map(function (r) {
      return '<li><span>' + r.name + '</span>' + formatRatePrice(r.price) + '</li>';
    }).join('');
  }

  function updateCartCount(count) {
    var el = document.querySelector('.header-cart__count');
    if (el && typeof count === 'number') el.textContent = count;
  }

  document.querySelectorAll('[data-shipping]').forEach(function (box) {
    var input = box.querySelector('[data-cep]');
    var btn = box.querySelector('[data-calc]');
    var list = box.querySelector('[data-results]');
    var mode = box.dataset.shipping; /* "product" ou "cart" */

    maskCep(input);
    var saved = localStorage.getItem(CEP_KEY);
    if (saved) input.value = saved;

    btn.addEventListener('click', function () {
      var cep = input.value.replace(/\D/g, '');
      if (cep.length !== 8) {
        list.innerHTML = '<li>Digite um CEP válido (8 dígitos).</li>';
        return;
      }
      localStorage.setItem(CEP_KEY, input.value);
      btn.disabled = true;
      var label = btn.textContent;
      btn.textContent = 'Calculando...';
      list.innerHTML = '<li>Consultando opções de entrega...</li>';

      var done = function () { btn.disabled = false; btn.textContent = label; };
      var fail = function (err) {
        var msg = 'Não foi possível calcular agora. Tente novamente.';
        if (err && err.message === 'cep-invalido') msg = 'CEP não encontrado. Confira o número e tente novamente.';
        if (err && err.message === 'unprocessable') msg = 'Não conseguimos cotar para este CEP. Confira o número ou finalize no checkout para ver o frete.';
        list.innerHTML = '<li>' + msg + '</li>';
        done();
      };

      if (mode === 'cart') {
        fetchRates(cep).then(function (rates) { renderRates(list, rates); done(); }).catch(fail);
        return;
      }

      /* Página de produto: adiciona 1 unidade temporariamente, calcula e restaura */
      var idInput = document.querySelector('.product-form [name="id"]');
      if (!idInput) { fail(); return; }
      var variantId = idInput.value;
      var prevQty = 0;

      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var item = cart.items.find(function (i) { return String(i.variant_id) === String(variantId); });
          prevQty = item ? item.quantity : 0;
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
          });
        })
        .then(function (addRes) {
          if (!addRes.ok) throw new Error('add-failed');
          return fetchRates(cep);
        })
        .then(
          function (rates) { renderRates(list, rates); return restore(); },
          function (err) {
            if (err && err.message === 'add-failed') {
              list.innerHTML = '<li>Produto indisponível para cálculo agora.</li>';
              done();
              throw err;
            }
            return restore().then(function () { fail(err); });
          }
        )
        .then(done)
        .catch(function () { done(); });

      function restore() {
        var updates = {};
        updates[variantId] = prevQty;
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: updates })
        })
          .then(function (r) { return r.json(); })
          .then(function (cart) { updateCartCount(cart.item_count); });
      }
    });
  });

  /* ---------- Produtos relacionados (Section Rendering API) ---------- */
  document.querySelectorAll('[data-related-url]').forEach(function (el) {
    fetch(el.dataset.relatedUrl)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var div = document.createElement('div');
        div.innerHTML = html;
        var content = div.querySelector('[data-related-url]');
        if (content && content.innerHTML.trim()) el.innerHTML = content.innerHTML;
        markHearts();
      })
      .catch(function () {});
  });

  /* ---------- Favoritos (wishlist via localStorage) ---------- */
  var WL_KEY = 'voxari_wishlist';

  function wlGet() {
    try { return JSON.parse(localStorage.getItem(WL_KEY)) || []; } catch (e) { return []; }
  }
  function wlSave(list) {
    localStorage.setItem(WL_KEY, JSON.stringify(list));
    wlCount();
  }
  function wlCount() {
    var n = wlGet().length;
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) { el.textContent = n; });
  }
  function markHearts() {
    var list = wlGet();
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      var active = list.some(function (x) { return x.handle === btn.dataset.handle; });
      btn.classList.toggle('is-active', active);
      var label = btn.querySelector('[data-wishlist-label]');
      if (label) label.textContent = active ? 'Salvo nos favoritos' : 'Adicionar aos favoritos';
    });
  }
  function renderWishlistPage() {
    var grid = document.querySelector('[data-wishlist-page]');
    if (!grid) return;
    var empty = document.querySelector('[data-wishlist-empty]');
    var list = wlGet();
    if (!list.length) {
      grid.innerHTML = '';
      if (empty) empty.style.display = 'block';
      return;
    }
    if (empty) empty.style.display = 'none';
    grid.innerHTML = list.map(function (item) {
      return '<div class="card-product">' +
        '<a href="' + item.url + '" class="card-product__media"><img src="' + item.image + '" alt="" loading="lazy"></a>' +
        '<div class="card-product__info">' +
          '<a href="' + item.url + '"><p class="card-product__title">' + item.title + '</p></a>' +
          '<span class="card-product__price">' + item.price + '</span>' +
        '</div>' +
        '<button type="button" class="wishlist-remove" data-wishlist-remove="' + item.handle + '">Remover dos favoritos</button>' +
      '</div>';
    }).join('');
  }

  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-wishlist-toggle]');
    if (toggle) {
      e.preventDefault();
      e.stopPropagation();
      var list = wlGet();
      var i = list.findIndex(function (x) { return x.handle === toggle.dataset.handle; });
      if (i >= 0) {
        list.splice(i, 1);
      } else {
        list.push({
          handle: toggle.dataset.handle,
          title: toggle.dataset.title,
          url: toggle.dataset.url,
          image: toggle.dataset.image,
          price: toggle.dataset.price
        });
      }
      wlSave(list);
      markHearts();
      renderWishlistPage();
      return;
    }
    var remove = e.target.closest('[data-wishlist-remove]');
    if (remove) {
      var l = wlGet().filter(function (x) { return x.handle !== remove.dataset.wishlistRemove; });
      wlSave(l);
      renderWishlistPage();
    }
  });

  wlCount();
  markHearts();
  renderWishlistPage();
});